import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../providers/auth.service';
import { MatSnackBar, MatDialog } from '@angular/material';
import { RecaptchaComponent } from 'angular-google-recaptcha';
import { Globals } from '../../../globals';
import { RecuperarDialog } from '../../../forms/usuarios/recuperar-dialog/recuperar-dialog.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { GeneralService } from '../../../providers/general.service';
import { TemaService } from '../../../providers/tema.service';
import { Observable } from 'rxjs';
import { ClienteService } from '../../../providers/cliente.service';

@Component({
  selector: 'app-relogin',
  templateUrl: './relogin.component.html',
  styleUrls: ['./relogin.component.scss']
})
export class ReloginComponent implements OnInit {

  user: string;
  service: string;
  cliente: string;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private clienteService: ClienteService
  ) { }

  ngOnInit() {
    this.authenticationService.logout();
    //Tomamos el valor que viene por get
    this.user = this.activatedRoute.snapshot.paramMap.get("user");
    this.service = this.activatedRoute.snapshot.paramMap.get("service");

    localStorage.setItem('idCliente', this.activatedRoute.snapshot.paramMap.get("cliente"));
    this.cliente = this.activatedRoute.snapshot.paramMap.get("cliente");
    //Llamar a una funcion relogin de Auth, que haga lo mismo que login pero que no requiera password.
    //Lo mismo hay que pedir en el backend, ir a una funcion relogin que no requiera password y le llegue el servicio.
    //Esta funcion nos enviara un ok, los permisos, y redireccionara al home de la aplicacion
    setTimeout(() => {
      this.relogin();
     //this.getEmpresa();
    }, 200);

  }
  relogin() {

    this.authenticationService.relogin(this.user, this.service).subscribe(
      respuesta => {
        if (respuesta.estado == 1) {
          // ingreso al sistema
          this.router.navigate(['/']);
        } else {
          console.log('datos incorrectos')
        }
      },
      error => {
        console.log('no ingreso')
      }
    );
  }
  getEmpresa() {
    this.clienteService.getDatosCliente(146).subscribe(respuesta => {
      localStorage.setItem('nombreCliente', respuesta.info.nombre);
    });
  }


}
